/**
 * Centralized color definitions for analytics bar charts
 */
export const CHART_COLORS = {
  BLUE: '#006E77',
  ORANGE: '#FFA93B',
  PURPLE: '#7A36EA',
} as const;

/**
 * Chart dataset color configuration
 */
export const CHART_DATASET_COLORS = {
  shares: {
    backgroundColor: CHART_COLORS.BLUE,
    borderColor: CHART_COLORS.BLUE,
    borderWidth: 0,
  },
  adds: {
    backgroundColor: CHART_COLORS.ORANGE,
    borderColor: CHART_COLORS.ORANGE,
    borderWidth: 0,
  },
  plays: {
    backgroundColor: CHART_COLORS.PURPLE,
    borderColor: CHART_COLORS.PURPLE,
    borderWidth: 0,
  },
} as const;

